export default __webpack_public_path__ + "static/media/banner.3ad3c7d3.png";